import { OrderStatus, ErrorCode } from '@triplabo/web/services/types';

export default {
  views: {
    dashboard: {
      title: '仪表板'
    },
    home: {
      title: 'GO×旅日打车',
      greeting: '嗨，我们出发吧!',
      go: '日本第一打车平台GO提供服务',
      loginButton: '立即登录',
      destinationPlaceholder: '您要去哪里？',
      pickUp: '上车',
      recommendPickup: '推荐上车点',
      recommendDropOff: '推荐下车点',
      cannotUsePoint: '禁止载客区',
      nowPlace: '现在地',
      nowPlaceJa: '現在地',
      categories: {
        recommend: '推荐',
        transportation: '交通',
        attraction: '景点',
        experience: '体验'
      },
      viewDetail: '查看',
      status: {
        finding: {
          title: '正在呼叫车辆',
          subtitle: '请您耐心等待'
        },
        dispatching: {
          subtitle: '司机马上就到'
        },
        pickUpArrived: {
          subtitle: '司机到达, 请尽快联系'
        },
        onDeliver: {
          subtitle: '车辆行驶中'
        }
      }
    },
    pickup: {
      title: '选择上车点',
      searchPlaceholder: '请输入上车点',
      recommendTitle: '为您推荐附近的上车点',
      historyTitle: '历史记录',
      empty: '暂无数据',
      emptyTip: '换个词试试，或用"地图选点"即刻发单',
      emptyButton: '地图选点',
      deleteConfirm: '确认删除吗？',
      deleteConfirmRecall: '确认',
      deleteConfirmCancel: '取消',
      facilityTag: '推荐'
    },
    pointChange: {
      searchUpPlaceholder: '请输入上车点',
      searchDownPlaceholder: '请输入下车点',
      title: '上车点变更',
      titleDropOff: '下车点变更',
      description: '拖动地图指针，可更改上车位置',
      descriptionDropOff: '拖动地图指针，可更改下车位置',
      confirm: '确认上车点',
      confirmDropOff: '确认下车点'
    },
    dropOff: {
      title: '选择下车点',
      searchPlaceholder: '请输入下车点',
      recommendTitle: '为您推荐附近的下车点'
    },
    orderConfirm: {
      discountApplied: '已优惠',
      paymentTimeoutDialog: {
        description: '系统繁忙, 请联系客服退款',
        subtitle: '请先截图保存，然后联系客服退款',
        goToService: '我已截图，去客服中心',
        orderIdLabel: '订单号'
      },
      paymentProcessing: '订单确认中，请勿关闭',
      ascfPayConfirm: {
        content: '已确认支付?',
        confirm: '确定',
        notPaid: '支付确认中，请在“我的行程”中刷新订单状态'
      },
      title: '现在打车，上车更快！',
      selectType: '选择车型',
      normal: '经济型的士',
      premium: '豪华型的士',
      wagon: '舒适型的士',
      airport: '机场定额',
      airportTag: '固定费用',
      airportTip: '日元固定金额，实际金额以当日支付平均汇率结算',
      confirm: '立即呼叫',
      time: '约{{min}}-{{max}}分钟上车',
      estimate: '预估',
      estimateTag: '预估车费',
      discount: '已优惠',
      unit: '元',
      coupon: '优惠券',
      couponAvailable: '{{count}} 张可用',
      checkOrderFailed: '检查订单状态失败，请稍后再试',
      callWaiting: {
        title: '当前附近无车辆是否继续呼叫？',
        subtitle: '我们将持续为您寻找可用车辆，并在找到后立即通知您',
        confirm: '继续呼叫',
        cancel: '取消呼叫',
        finding: '正在寻找附近车辆...',
        dispatching: '车辆调度中，请耐心等待',
        continueWaiting: '附近没有车辆，是否继续等待？',
        continue: '继续等待',
        unwait: '不等了'
      }
    },
    profile: {
      title: '我的',
      order: '我的行程',
      coupon: '优惠券',
      service: '客服中心',
      userName: '用户名',
      editProfile: '编辑资料',
      notLogin: '未登录',
      goToLogin: '登录账户',
      logout: '退出登录',
      creditCard: '信用卡管理'
    },
    editUserInfo: {
      title: '修改个人信息',
      name: '姓名（拼音）',
      email: '联系邮箱（收取电子收据）',
      phone: '联系电话',
      confirm: '确认修改',
      emailError: '请输入正确的邮箱地址',
      phoneError: '请输入正确的手机号码',
      nameError: '请输入正确的姓名',
      success: '修改成功',
      error: '修改失败，请稍后再试'
    },
    order: {
      all: '全部',
      succeed: '已完成',
      pending: '待支付',
      canceled: '已取消',
      empty: '暂无订单',
      emptyTip: '快去呼叫用车吧',
      noMore: '没有更多了',
      orderId: '订单号',
      carType: {
        normal: '经济型',
        premium: '豪华型',
        wagon: '舒适型',
        airport: '机场定额',
        any: '经济型'
      },
      status: {
        [OrderStatus.Succeed]: '已完成',
        [OrderStatus.Canceled]: '已取消',
        [OrderStatus.Finding]: '呼叫中',
        [OrderStatus.DispatchFailed]: '呼叫中',
        [OrderStatus.Dispatching]: '行程中',
        [OrderStatus.PickUpArrived]: '行程中',
        [OrderStatus.OnDeliver]: '行程中',
        [OrderStatus.DropOff]: '已完成',
        pending: '待支付'
      },
      money: '{{amount}}'
    },
    payment: {
      title: '预付车费',
      description:
        '为确保顺利发单，请您按照预估价支付车费，行程结束后按实际费用多退少补。',
      wechat: '微信支付',
      wechatDesc: '使用人民币支付，适用于大陆微信用户',
      agreement: '我已认真阅读并同意',
      agreementLink: '《预付款协议》',
      confirm: '预支付{{amount}}元',
      money: '{{amount}}<span>元</span>',
      support: '支持'
    },
    cancelOrder: {
      success: '订单已取消',
      confirmCancel: {
        title: '确认取消订单',
        warning: '当您取消订单时，可能会产生取消费用，请您确认是否要取消订单？',
        note: '为维护良好打车生态，频繁取消可能会被限制下单，感谢您的支持和理解！',
        viewRules: '查看取消规则',
        waitMore: '我再等等',
        confirm: '取消订单',
        cancelFee: '取消费',
        cancelFeeDescription: '{{amount}}元'
      },
      selectReason: {
        title: '选择取消原因',
        submit: '确认提交',
        otherReason: '其他原因',
        customReasonPlaceholder: '如有其他原因，请在这里告诉我们',
        reasons: {
          platform: {
            title: '平台相关',
            content: {
              tooFar: '平台派单太远',
              inaccurateLocation: '定位不准/找不到上车位置',
              notExpectedCar: '不是我预期的车型'
            }
          },
          driver: {
            title: '司机相关',
            content: {
              driverNotComing: '司机不来接我（车不动/离我越来越远）',
              driverNotContactable: '联系不上/找不到司机',
              driverCancel: '司机要求取消订单',
              driverLate: '司机迟到',
              driverNotMatch: '不是订单显示车辆或司机'
            }
          },
          self: {
            title: '自身原因',
            content: {
              selfChange: '自身行程有变，暂时不用车',
              otherPlatform: '在其他平台打到车',
              cannotArrive: '无法及时赶到上车点'
            }
          }
        }
      }
    },
    fareEstimate: {
      title: '车费预估',
      unit: 'JPY',
      hero: {
        title: '车费预估说明',
        subtitle: '应答快、接驾快、性价比优选'
      },
      fee: {
        title: '费用构成预估',
        totalLabel: '预估金额',
        approx: '约',
        range: '{{min}}~{{max}}',
        items: {
          transport: '运输费（含手续费）',
          carTypeFee: '车型费',
          pickup: '迎车费',
          dispatch: '调度费（含远距调度等）',
          service: '平台手续费',
          regional: '地域振兴费',
          peak: '高峰调整',
          etc: '过路费（含ETC等）',
          coupon: '优惠券抵扣'
        },
        notes: {
          estimate:
            '预估价根据实际交通状况、预计行驶里程、时间以及汇率波动等因素估算得出，存在波动，仅供参考。',
          service: '平台手续费根据实际行驶里程，阶梯式计算。',
          extra:
            '高速费、路桥费等行程中实际产生的其他附加费用不包含在预估价中，最终以行程结束后实际结算金额为准。'
        }
      },
      faq: {
        title: '常见问题',
        q: '问',
        a: '答',
        items: {
          why: {
            question: '为什么实际价格比预估价格高？',
            answer:
              '在您下单前，可以看到车型的行程报价，此报价只是预估费用，如果实际价格高于预估价格，这可能是因为交通堵塞、行程中的额外停留、附加收费（如过路费）等，都会导致价格变化。'
          },
          extraFee: {
            question: '附加费是由乘客来支付吗？',
            answer:
              '行程中产生的高速费、路桥费、停车费等附加费用，将根据实际情况由乘客承担。'
          },
          routeChange: {
            question: '路线变更是否会影响行程价格？',
            answer:
              '若行程中因实际路况、乘客需求等原因发生路线变更，最终结算金额将以实际行驶里程和时间为准。'
          },
          cancelFee: {
            question: '取消订单会产生取消费用吗？',
            answer:
              '在司机接单后超过免费取消时间或司机已到达接驾点取消订单，将根据规则收取相应的取消费用。'
          }
        }
      }
    },
    orderDetail: {
      empty: '暂无数据',
      serviceProvider: '由GO Inc. 提供本次服务',
      more: {
        title: '更多',
        orderId: '订单号:{{orderId}}'
      },
      finding: {
        title: '正在呼叫车辆...',
        estimatedTime: '预计{{time}}分钟内被应答，已等',
        cancelButton: '取消订单'
      },
      remaining: '剩余',
      minutes: '分钟',
      meter: '米',
      kilometers: '公里',
      canceled: {
        title: '订单已取消',
        subtitle: '如有需要，可重新呼叫用车',
        provider: '由GO Inc. 提供本次服务',
        customerService: '联系客服',
        paymentDetail: '预付款详情',
        recallButton: '重新叫车',
        backHome: '返回首页'
      },
      succeed: {
        title: '行程已结束',
        provider: '由GO Inc. 提供本次服务',
        actualPay: '实付',
        unit: '元',
        customerService: '联系客服',
        getInvoice: '获取收据',
        drivingFee: '行程费金额',
        additionalPaymentAmount: '补缴金额',
        prepaid: '金额结算中',
        discount: '优惠金额'
      },
      getInvoice: {
        title: '开具电子收据',
        description: '电子收据将以邮件附件的方式发送到您的邮箱',
        invoiceTitle: '发票抬头',
        invoiceTitlePlaceholder: '请输入发票抬头',
        email: '邮箱地址',
        emailPlaceholder: '请输入邮箱地址',
        emailError: '请输入正确的邮箱地址',
        remark: '备注',
        remarkPlaceholder: '请输入备注',
        submit: '提交',
        success: '电子收据已发送至您的邮箱',
        error: '收据发送失败，请稍后再试'
      },
      confirmDialog: {
        noDriver: '没有找到附近司机，请问要重新呼叫吗？',
        recall: '重新呼叫',
        cancel: '取消订单',
        driverCancel:
          '司机取消订单，本次订单已取消，自动发起退款，稍后到账至您的钱包',
        driverCancelConfirm: '我知道了'
      },
      rideCode: {
        title: '乘车码',
        description: '上车后,请向司机出示以下乘车码',
        waitingNumber: '待合わせ番号',
        destination: '目的地です'
      },
      receive: {
        cardTitle: '上车后请向司机出示您的乘车码',
        viewCode: '查看乘车码',
        dispatchingText: '司机已接单',
        dispatchingDescription: '司机正在赶往上车地点',
        pickUpArrivedText: '司机已到达',
        pickUpArrivedDescription: '请您尽快联系司机上车',
        onDeliverText: '正在前往目的地',
        onDeliverDescription: '行程已开始，请系好安全带',
        message: '发消息',
        cancelOrder: '取消订单',
        shareTrip: '行程分享'
      }
    },
    repay: {
      statusText: '订单待支付...',
      serviceProvider: '由GO Inc. 提供本次服务',
      service: '联系客服',
      paidText: '补交',
      unit: '元',
      feeUnit: '{{amount}}',
      repayment: '补交车费',
      drivingFee: '行程费金额',
      prepaidAmount: '预付金额'
    },
    repayDetail: {
      title: '预付款详情',
      prepaymentAmount: '预付金额',
      actualUsage: '行程结束,实际使用',
      unusedPrepayment: '未使用预付款',
      finishedRefund: '订单完成，未使用预付款原路退回',
      unusedPrepaymentRefund: '订单取消，未使用预付款原路退回',
      paymentReminder: '需补缴车费，请返回支付',
      additionalFarePaid: '订单完成，已补缴车费',
      cancelFee: '取消手续费',
      insufficientPrepaymentNotice:
        '当预付款不足以抵扣您本次出行的实际车费时，您需就不足部分继续进行支付，否则您将无法继续使用出行服务。',
      bankProcessingNote:
        '实际划账时间以银行到账时间为准,若7个工作日内未到账,请联系客服',
      cancelFeeNote:
        '配车成功后，因乘客原因取消订单的情况下，需支付取消手续费。',
      cny: '元',
      unit: 'JPY'
    },
    chat: {
      tips: {
        templateOnly: '仅支持发送下方模板信息',
        translation: '司乘消息将被自动翻译成对方熟悉语言。'
      }
    },
    hotelHome: {
      title: '打车出行',
      wechatScan: {
        title: '微信扫一扫',
        description: '手机扫码进入微信小程序，查看更多产品'
      }
    },
    hotelDropOff: {
      title: '选择下车点'
    },
    hotelOrderConfirm: {
      title: '确认订单',
      unit: 'JPY',
      modify: '修改'
    },
    hotelPayment: {
      title: '预付车费',
      description: '请使用手机扫描下方二维码进行支付',
      money: '<span>JPY</span>{{amount}}',
      alertText:
        '为确保顺利发单，请您按预估价支付车费，行程结束后按实际费用多退少补，预付款未使用部分将按照原路退还。'
    },
    hotelPrePayTerms: {
      title: '预付款协议',
      headDesc: `鉴于您已注册成为"GOx旅日打车"（以下简称"我司"）平台用户，并根据平台规则，在使用我司提供的出行服务时可能需要预先支付费用，特订立本预付款协议（以下简称"本协议"）。
  请您仔细阅读本协议内容，并在充分理解和同意后使用本服务。未成年人应在法定监护人的陪同下阅读并同意本协议。您点击"同意"或使用本服务，即视为您已阅读、理解并接受本协议的全部内容，并愿意履行相关义务，承担相应责任。`,
      content: [
        {
          title: '预付款支付规则',
          content: [
            '为便捷您使用打车服务，我司提供预付款支付方式。在行程开始前，您需按照平台预估费用预先支付车费。',
            '预付款金额将基于您选择或预约的出行需求，并按照平台公示的计价规则进行预估。该预付款将在您实际使用服务后用于抵扣相应费用。',
            '您确认行程并支付预付款后，订单即正式生效。如您未支付预付款，将无法提交订单，也无法使用我司平台内的司机服务。'
          ]
        },
        {
          title: '预付款的结算与调整',
          content: [
            '预付款仅用于打车订单支付，不构成充值行为。',
            '订单生效并完成行程后，系统将根据实际费用进行结算，按"多退少补"原则处理。',
            '若预付款超出实际费用，平台将在行程结束后按原支付路径退还余额，具体退款时间取决于银行或第三方支付机构的处理时限。',
            '若预付款不足以支付实际费用，您需补足差额，完成支付后方可继续使用平台服务。'
          ]
        },
        {
          title: '订单取消与退款',
          content: [
            '在支付预付款并生成订单后，如因非您个人原因（包括但不限于订单未被接受、不可抗力事件等）导致行程未能完成，平台将全额退还预付款，退款路径与支付路径一致。',
            '若您在订单生成后主动取消，并被认定为"有责取消"，平台将根据相应计价规则扣除费用，并退还剩余款项。',
            '退款时限取决于银行或第三方支付机构的处理时间，通常不超过7个工作日。如退款出现问题，您可联系平台客服，我们将协助与支付机构沟通处理。'
          ]
        },
        {
          title: '法律适用与争议解决',
          content: [
            '本协议是《GOx旅日打车用户协议》的组成部分，未尽事宜以用户协议为准。本协议与用户协议、隐私政策等文件共同构成本服务的法律依据。如本协议与其他相关文件存在冲突，以本协议为准。',
            '本协议适用日本法律。若因本协议引发争议，双方应友好协商解决；协商不成的，可提交有管辖权的法院裁决。'
          ]
        },
        {
          title: '其他条款',
          content: [
            '若本协议任何条款在任何时候被认定为不合法、无效或无法适用，但不影响整体协议效力的情况下，其他条款仍然有效。我司有权对相关条款进行合理调整，使其符合适用法律。',
            '我司保留对本协议的最终解释权，并可根据业务需要适时修订协议内容，修改后的协议将在平台公示，用户继续使用服务即视为接受修订后的协议。'
          ]
        }
      ]
    },
    hotelPayResult: {
      success: {
        title: '支付成功',
        description: '正在跳转'
      },
      fail: {
        title: '支付失败',
        subtitle: '请尝试重新下单',
        description: '请检查您的网络、银行卡余额等是否正常',
        btnText: '返回打车页',
        seconds: '{{amount}}s'
      }
    },
    hotelOrderDetail: {
      requestSuccess: '叫车成功'
    },
    login: {
      title: '登录/注册',
      content: {
        title: '请选择登录/注册会员的方式',
        description: '*可使用第三方账户轻松登录、注册会员',
        agreement:
          '*当您使用邮箱或第三方账户登录时，将视同您已经同意相关<terms>{{terms}}</terms>与<privacy>{{privacy}}</privacy>',
        terms: '《使用条款》',
        privacy: '《隐私政策》'
      },
      button: {
        google: 'Google',
        email: 'Email',
        nextStep: '下一步',
        signIn: '注册新账户'
      },
      email: {
        label: '邮箱'
      }
    },
    couponList: {
      title: '优惠券包',
      tabs: {
        inputCode: '输入优惠码',
        shareCoupon: '分享优惠码'
      },
      inputPlaceholder: '请输入优惠码',
      condition: '行程总预估费超过JPY{{amount}}可用',
      applyTo: '适用于豪华型计程车',
      validUntil: '有效期至',
      minSpend: '满JPY{{amount}}可用',
      maxDiscount: '最高减{{amount}}日元',
      noMinSpend: '无最低费用门槛',
      useButton: '去使用',
      validDate: '{{start}}至{{end}}使用',
      empty: '暂无优惠券',
      emptyTip: '快去领取优惠券吧',
      couponType: {
        NEW_USER: '新用户折扣券',
        SHARE: '邀请券',
        SHARE_REWARD: '好友邀请返回券',
        BUNDLE: '套餐券',
        PROMOTION: '限时优惠券',
        AIRPORT_COUPON: '机场定额优惠券',
        UNKNOWN_COUPON_TYPE: '未知券'
      }
    },
    showDialog: {
      title: '分享邀请码，共得好礼！',
      description:
        '好友邀请券请点击“查看券包”，邀请兑换得<span>大额优惠券</span>',
      rideButton: '立即打车',
      shareButton: '分享邀请码'
    },
    shareCoupon: {
      title: '分享邀请码',
      headline: '邀请好友一起享受乘车优惠！',
      description:
        '邀请好友成功注册,好友可得9.5折券(最高可以抵500日元),完成首乘后您可得200日元券(7天内使用),邀约无上限',
      description2:
        '邀请好友输入您的专属优惠码后，\n好友可得<span>立减2000日元优惠券</span>，\n好友乘车后您可得<span>立减1000优惠券</span>！\n自动发放至券包，领取后15天内有效。\n可邀请多位，好友一起GO！',
      campaignDate: '（活动时间至26年10月12日，前2000名可领）',
      linkLabel: '邀请链接',
      inviteCodeLabel: '专属邀请码',
      copyButton: '复制',
      copySuccess: '复制成功',
      copyFailed: '复制失败'
    },
    redeemCoupon: {
      title: '输入优惠码',
      codeLabel: '优惠券码',
      placeholder: '请输入优惠券码',
      confirmButton: '确认兑换',
      instruction1: '*输入优惠券兑换码,点击【确认兑换】完成兑换;',
      instruction2:
        '*每个兑换码仅可成功兑换一次,兑换成功后请在有效期限内使用,过期作废。',
      emptyCode: '请输入优惠券码',
      redeemSuccess: '兑换成功',
      redeemFailed: '兑换失败，请稍后再试'
    },
    getCoupon: {
      title: '领取优惠券',
      coupon: {
        title: '新用户折扣券',
        validity: '有效期至 {{validity}}',
        discount: '{{value}}%<unit>折扣</unit>',
        minimumSpend: '满JPY{{amount}}可用',
        usageCondition: '行程总预估费超过JPY{{amount}}可用'
      },
      button: {
        claim: '立即领取'
      },
      terms: {
        itema: '*首次注册且未打过车的用户可领取',
        itemb:
          '*需登录后才能领取,过期或未登录不能领取,每次扫码仅有一次领取机会',
        itemc: '*领取成功后,可进入我的优惠券包,查看和使用',
        itemd: '*限7天内使用,过期失效'
      },
      success: {
        title: '领取成功',
        description: '优惠券已成功加入券包,可进入我的—优惠券包,查看和使用',
        viewButton: '查看优惠券',
        gotItButton: '我知道了'
      },
      newComer: {
        title: '恭喜获得多重好礼！',
        description:
          '好友邀请券请点击"查看券包"，分享专属邀请码，或输入优惠码兑换优惠',
        rideButton: '立即打车',
        viewButton: '查看券包',
        coupon: {
          discountUnit: '{{value}}<unit>折</unit>',
          jpyUnit: '<unit>JPY</unit>{{value}}',
          maxDiscount: '最高减{{amount}}日元',
          validity: '有效期至 {{validity}}'
        }
      }
    },
    signIn: {
      register: '注册',
      login: '登录',
      email: {
        label: '邮箱'
      },
      password: {
        label: '密码'
      },
      button: {
        register: '注册',
        signIn: '登录'
      },
      forgetPassword: '忘记密码？',
      validate: {
        email: {
          invalid: '请输入正确的邮箱'
        },
        password: {
          required: '请输入密码'
        }
      }
    },
    reset: {
      title: '重置密码',
      email: {
        label: '邮箱'
      },
      button: {
        reset: '发送邮件重设密码',
        backToSignIn: '返回登录'
      },
      sendResetEmailSuccess:
        '密码重置链接已发送至 <email>{{email}}</email> 请检查您的邮箱并重置密码。'
    },
    service: {
      title: '客服中心',
      categories: {
        fee: '费用相关',
        driver: '司机相关',
        other: '其他问题'
      },
      items: {
        fee: {
          estimatedCost: {
            label: '预估费用',
            content:
              '预估费用会帮助您大概了解行程花费。输入您的上下车地点后，进入下一个页面，即可看到预估费用。预估费用是在考虑最短路径和预估行驶时间后计算出的最优价格。实际收费可能因交通、天气、道路施工或不同路线等因素的影响而有所差异。请知悉：预估费用仅在下单时有效。过路费或机场费等附加费用不包括在预估费用中。此报价只是预估费用，我们不能保证行程实际收费不会高于预估费用。'
          },
          costBreakdown: {
            label: '费用明细',
            content:
              '您的行程费用是综合多种因素后计算得出，因地区和网约车供应商不同而有所差异。在计算价格的时候，供应商主要参考如下三个因素；1.起步价 2.里程费（行程距离） 3.时长费（行程时间） 其他可能影响实际费用的因素 1.动态运价，如"峰时价格"等 2.过路费和机场费 3.车辆类别 4.小程序服务费 如果实际收费与您的预期费用不同，请参考关于"实际收费高于预估费用"问题的解答。请知悉：电子收据上目前没有费用明细。行程结束时，我们会向您发送网约车供应商计算出的实际费用。当您使用小程序时，即被视为您接受小程序上显示的价格和扣除的费用即为行程的实际收费。实际收费有可能与出租车计价器上的价格不同。'
          },
          additionalFees: {
            label: '高速费，机场费等附加费用',
            content:
              '请注意，机场费、高速费、过路费等其他附加费用不包括在预估费用中；所有这些附加费用都需由乘客承担。不过，司机有可能会在行程结束前将这些费用添加到实际车费中。'
          },
          cancellationFees: {
            label: '取消订单费用',
            content:
              '为补偿司机的空驶距离和时间，如果您在以下两种情况下取消订单，则可能需要支付订单取消费用。1.司机接单并已经问您的上车地点行驶了一定时长或里程之后。2.司机已经到达上车地点并等待超过一定时长，在这种情况下即使司机取消订单，您也需要支付订单取消费用。收取订单取消费用有助于网约车供应商保持高效运作，确保更快的派车速度。请注意，订单取消费用可能会因地点和网约车供应商的不同而有差异。如果您认为收费不合理，请通过"联系客服"按钮联系我们的客服团队，我们将尽最大的努力帮助您解决。'
          },
          actualCostHigher: {
            label: '实际费用高于预估费用',
            content:
              '在您下单之前的报价只是预估费用，我们不能保证行程实际收费不会高于预估费用。如果实际收费高于预估费用，可能是由于以下原因：1.交通堵塞 2.附加收费，如过路费或机场费等 3.行程中的额外停留 4.司机选择了另外一条路线 5.导航或是网络问题 如果您对实际收费有任何的疑问，请通过"联系客服"按钮联系我们的客服团队，我们会尽力协助您解决。'
          },
          vehicleDamage: {
            label: '车辆损坏和清洁费用',
            content:
              '如果乘客弄脏了车辆，乘客需要承担清洁费用。当出现上述情况时，司机有权在实际收费中加上清洁费。这部分费用将直接支付给司机用于车辆清洁。请乘客不要在车上进食或饮酒，协助保持车辆的干净整洁。'
          }
        },
        driver: {
          longerRoute: {
            label: '司机选择了较长的行驶路线',
            content:
              '司机有权按照导航推荐选择最快或最短路线行驶。如果行程结束时，实际收费超过了预估费用，可能是因为司机选择了一条较长的行驶路线（为了避开交通堵塞或某些道路突发状况）。如果您有首选路线，请在出发前与司机沟通并达成一致，以免产生任何误解。如果实际收费明显高于您的预期，请通过"联系客服"按钮联系我们的客服团队，我们会尽力协助您解决。'
          },
          orderNotEnded: {
            label: '下车后司机没有结束订单',
            content:
              '司机应在您下车时或不久之后立即结束订单。如果由于司机没有及时结束订单而造成实际收费明显高于预估费用，请通过"联系客服"按钮联系我们的客服团队，我们会尽力协助您解决。'
          }
        },
        other: {
          lostItems: {
            label: '物品丢失',
            content:
              '我们非常理解您丢失物品的急切心情，我们会尽力帮助您找回物品。请点击下方的"联系客服"按钮与我们的客服团队沟通核实，同时请提供以下信息：1.请详细描述您丢失的物品 2.若物品已被找回，您希望在哪里取回物品？ 3.请留下您的电话号码，以便我们协助找回物品后，及时与您取得联系 4.请问您会在此地停留多久？ 在收到以上信息之后，我们会尽快联系网约车供应商，并尽力帮助您找回物品。请注意因为隐私保护法，我们无法向您提供司机的联系方式。请知悉：我们会尽最大努力帮助您找回丢失的物品，但是无法对行程中丢失的物品担负任何责任。'
          },
          otherIssues: {
            label: '其他问题',
            content:
              '如果您对订单或我们的服务有其他的问题和建议，请通过下面的"联系客服"按钮联系我们的客服团队，我们会尽力协助您解决。'
          }
        }
      },
      contact: '联系客服'
    },
    privacy: {
      title: '隐私政策',
      lastUpdated: '最近更新日期 2022年03月18日',
      company: 'リンクティビティ株式会社',
      contentTitle: '个人信息保护方针',
      subTitle:
        '本公司通过本公司经营的预约网站LINKTIVITY收集用户的个人信息。本公司认为，为了让用户安心便捷地预订商品，保护用户的个人信息非常重要，因此本公司通过遵守以下规定来应对个人信息：',
      content: [
        {
          title: '用户个人信息的管理者',
          content:
            'LINKTIVITY株式会社\n〒100-0011 东京都千代田区内幸町2-1-6 日比谷公园前19楼'
        },
        {
          title: '信息采集',
          content:
            '除法律要求的情况外，本公司在征得用户同意后，为实现本公司的使用目的，向用户采集最低限度的个人信息。'
        },
        {
          title: '信息使用',
          content:
            '本公司仅在为实现本公司所规定的使用目的时，使用从用户那里采集的个人信息。'
        },
        {
          title: '保管和保存',
          content:
            '本公司为了确保从用户处获取的个人信息不会外泄，会对个人信息进行保管和保存等工作，并确保系统的安全。'
        },
        {
          title: '销毁和删除',
          content:
            '当个人数据（指个人信息保护法规定的个人信息，以下同）不再需要使用时，本公司会及时销毁。'
        },
        {
          title: '用户咨询等处理',
          content:
            '针对用户要求告知使用目的，开示要求、修正/添加/删除要求、停止使用/删除要求及停止提供给第三方提供等请求，本公司会根据法律要求进行处理。'
        },
        {
          title: '安全管理措施等',
          content:
            '本公司会对所有与LINKTIVITY服务相关的员工进行教育，让员工理解个人信息的重要性，并采取必要和适当的措施来管理个人信息的安全。'
        }
      ],
      rules: [
        {
          title: '1. 本公司取得的个人信息及其使用目的',
          subtitle:
            '本公司将出于以下目的，采集并使用用户的住址、姓名、出生日期、联系方式、电子邮箱地址或护照号码等个人信息。此外，未经用户同意，本公司不会采集需要特别注意的个人信息。向用户采集个人信息时，个人信息使用目的未公开时，应将个人信息使用目的告知用户或公开明示。此外，未经父母同意，本公司不会采集未满13周岁儿童的个人信息。当本公司采集未满13周岁儿童的个人信息时，则将视为已获得监护人同意，但如果明确没有同意，则本公司不会将该个人信息用于联系监护人等以外用途。',
          rule: [
            {
              title: 'i. LINKTIVITY服务使用（会员注册等）目的',
              content:
                '为了使用LINKTIVITY服务，本公司将在公司内部共享用户个人信息。\n法律依据：为了提供用户要求的服务或功能所必需。'
            },
            {
              title: 'ii. 购票申请',
              list: [
                {
                  title: '个人信息采集项目',
                  content:
                    '当用户向商品供应商申请购买门票时，本公司将采集用户的姓名、付款信息、护照号码以及与用户健康状况相关的信息等。'
                },
                {
                  title: '具体使用目的',
                  content:
                    '本公司将采集用户的个人信息，以便确认用户的购票资格和付款等事项。此外，为了实现该目的，本公司将向商品供应商、交通运输机构、付款结算提供商（包括海外提供商等）等提供用户的个人信息。'
                }
              ],
              subtitle: '法律依据：为了满足用户的服务需求和提供必要的功能。'
            },
            {
              title:
                'iii. 为了向用户发送通知，包括新闻通讯（电子邮件杂志等），本公司将在用户的同意后收集个人信息',
              content: '法律依据：基于用户同意收集信息。'
            },
            {
              title: 'iv. 通过社交媒体和广告投放平台进行广告推送',
              content: '法律依据：基于用户同意收集信息。'
            },
            {
              title: 'v. 为请求填写问卷调查',
              content:
                '法律依据：在用户同意的基础上收集个人信息，以改进本公司预订网站、商品、服务等内容。'
            },
            {
              title: 'vi. 为分析和管理用户信息',
              content:
                '法律依据：通过改进本公司的预订网站、产品、服务等内容，以追求和保护用户的合法利益。'
            },
            {
              title: 'vii. 检测未经授权使用的信用卡等',
              content:
                '法律依据：为确保用户信用卡的安全性，以追求和保护用户的合法利益所必需。'
            }
          ]
        },
        {
          title: '2. 个人信息的第三方提供',
          subtitle:
            '本公司不会将获取的用户个人信息提供给第三方，但以下情况除外：\n\ni.当用户向第三方（包括商品供应商、海外旅行社、社交媒体运营商、广告服务公司和其他企业）提供个人信息时。 当用户通过同意本隐私政策或其他方式事先同意向第三方提供个人信息的情况。\nii.在必要范围内委托外部机构处理个人信息的情况。\niii.基于法律要求提供个人信息的情况。\niv.为保护个人的生命、身体或财产而有必要的情况下，并且无法获得用户同意的情况。\nv.为改善公共卫生或促进儿童的健康成长而特别需要时，并且无法获得用户同意的情况。\nvi.与国家、地方政府等合作执行法定事务时，并且获得用户同意可能会影响到该事务的实施。',
          rule: []
        },
        {
          title: '3. 委托处理个人信息',
          subtitle:
            '当公司在必要的情况下，基于上述条款，将用户的个人信息委托给第三方，对委托方进行必要和适当的监督，以实现公司的目的。如果委托方再次委托，则公司将直接或间接监督委托方是否对再次委托方进行必要和适当的监督。对于再再次委托的情况，公司将同样进行监督。\n如果本公司根据上述规定，在实现本公司使用目的的必要范围内委托第三方处理用户的个人信息，本公司将对受托方进行必要和适当的监督。此外，如果受托方重新委托数据，本公司将直接或间接监督受托方是否对重新委托方进行必要和适当的监督。 同样的情况也应适用于再收货人重新委托的情况。',
          rule: []
        },
        {
          title: '4. 获取Cookie信息等',
          rule: [
            {
              title: 'i. Cookie',
              content:
                'Cookie是存储在用户硬盘商的一段数据，包含有关用户的信息。本公司不使用Cookie做为个人识别信息。此外，由于是暂时性Cookie，一旦用户关闭了浏览器，Cookie将不会被保存。本公司使用Cookie来提高服务质量、定制本公司的网站以及测量广告效果等。\n此外，本公司将Cookie作为统计数据进行分析，以探测用户的兴趣和关注点，并防止未经授权的访问。\n用户可以根据自己的需求禁用Cookie，但这将导致用户无法在LINKTIVITY上进行预订。'
            },
            {
              title: 'ii. 日志/文件',
              content:
                '本公司会自动收集特定信息并将其保存在日志文件中。这些特定信息包括IP（Internet Protocol）地址、浏览器类型、ISP（Internet Service Provider）、引用/退出页面、操作系统、日期/时间戳等。本公司利用这些信息监视未经授权的访问。此外，本公司还进行用户趋势分析、网站管理和用户行为跟踪。\n然而，本公司在使用上述信息时，确保不会识别特定个人，且不会将获取的信息用于上述以外的任何其他目的。'
            },
            {
              title: 'iii. Web Beacon',
              content:
                '本公司使用 Web Beacon 来进行访问分析和联盟计划。本公司不会将 Web Beacon 用于除上述目的之外的任何其他目的，也不会用于识别特定个人。'
            },
            {
              title: 'iv. 统计分析',
              content:
                '本公司利用第三方访问分析工具来确认哪些网站和服务受欢迎，并记录用户在LINKTIVITY网站内的访问页面以及页面历史。\n本公司使用这些数据，向对特定领域感兴趣的用户提供LINKTIVITY内符合其兴趣的内容和广告。\n此外，本公司可能会收集与个人身份无关的统计信息。此外，本公司收集的Cookie信息和其他公司收集的Cookie信息，可能会在第三方访问分析工具上相互查看。'
            }
          ]
        },
        {
          title: '5. 匿名处理信息的处理',
          rule: [
            {
              title: '1. 创建匿名信息处理：',
              content:
                '本公司在创建匿名信息时会遵守以下规定。匿名信息处理是指将个人信息处理后得到的个人相关信息，采取法律规定措施而无法识别特定个人，并且无法恢复原个人信息。\n\n1) 遵循法律规定的标准，进行适当的处理；\n2) 按照法律规定的标准，采取安全措施，防止删除的信息或处理方法的信息泄露；\n3) 公开已经处理成匿名信息的信息项目；\n4) 不采取任何行动来进行本人识别行为。'
            },
            {
              title: '2. 提供经匿名处理的信息',
              content:
                '如果要向第三方提供经匿名处理的信息，本公司则应公布要提供的经匿名处理的信息中与个人有关的信息项目和提供方法，并明确告知接受信息的第三方，该信息是经匿名处理的信息。'
            },
            {
              title: '3. 关于匿名处理信息的公开',
              content:
                '关于匿名处理信息的制作\n对于以下用户的个人信息，本公司将在采取适当措施以确保无法识别特定个人和无法恢复个人信息的情况下持续制作匿名处理信息。\n\n匿名处理信息中包含的与个人有关的信息项目\n有关提供平台服务而获取的信息\n购买日期、参加日期、优惠券语言、销售价格范围、参加人数、预订状态（已确认预订或取消等）、供应商所在地区和都道府县信息、旅行社所在国家/地区\n\n向第三方提供匿名处理的信息\n针对本公司创建或持有的匿名处理的信息，本公司将明确其为匿名处理信息后，持续提供给第三方。\n\n匿名处理信息中包含的与个人有关的信息项目\n与上述"关于匿名处理信息的制作"中的"匿名处理信息包含的与个人有关的信息项目"相同的项目\n\n提供方式\n通过电子通信方式（电子邮件、上传到服务器、API链接等）或 DVD等物理媒介发送受密码保护的电子文件。'
            }
          ]
        },
        {
          title: '6. 个人信息的安全管理措施',
          subtitle:
            '为了防止个人信息泄露、盗用、滥用、非法访问、篡改和破坏，本公司采取了组织、技术和物理安全管理措施。对本公司存储个人信息的服务器的访问仅限于持有ID/PW的特定员工，特别是对某些个人信息的管理，只允许数据管理所需的最低数量的员工访问。\n\n此外，包含信用卡信息在内的个人信息分布在多个数据中心，并存储在安全的环境中。我们还在所有预订交易页面上使用安全套接字层 (SSL) 加密。 通过使用支持 SSL 的浏览器，您可以对通过 Internet 传输的个人信息和信用卡信息保密。\n\n此外，处理用户个人信息的员工在离开终端时将使用受密码保护的屏幕保护。\n\n此外，本公司每月对部分部门进行一次关于个人信息等重要性的教育和培训，对整个公司至少每六个月进行一次，并保留教育记录。',
          rule: []
        },
        {
          title: '7. 关于用户个人信息处理的权利',
          subtitle:
            '根据2016年4月27日生效的欧盟通用数据保护条例（GDPR）2016/679，关于个人信息的处理，用户有以下权利：',
          rule: [
            {
              title: 'i.访问权'
            },
            {
              title: 'ii.更正权'
            },
            {
              title: 'iii.删除权（遗忘权）和限制处理权'
            },
            {
              title: 'iv.数据可携性权'
            },
            {
              title: 'v.反对权'
            },
            {
              title: 'vi.拒绝基于自动处理（包括个人画像）做出的决定的权利。'
            }
          ]
        },
        {
          title: '8. 关于公开、修正、停止使用等的请求',
          subtitle:
            '本公司将通过下文第11条所列的联络窗口对下列请求作出回应：用户提供的使用目的、公开请求、修改/追加/删除请求、停止使用、消除请求以及暂停向第三方提供所保留的个人信息的请求（以下统称"公开请求等"）。\n\n此外，本公司也可根据用户要求，在用户的个人页面上更改和确认会员信息以及停止邮件杂志等服务。',
          rule: []
        },
        {
          title: '9. 外部链接',
          subtitle:
            'LINKTIVITY网站包含指向其他网站的链接。本隐私政策仅适用于LINKTIVITY网站收集的信息，对于其他网站的隐私政策或内容，本公司不承担任何责任。用户在访问其他链接的网站时，建议阅读其隐私政策，并确认其个人信息的处理方式。',
          rule: []
        },
        {
          title: '10. 隐私政策的变更',
          subtitle:
            '本公司将隐私政策发布在LINKTIVITY网站上，使用户能够知悉本公司获取、使用用户个人信息的目的以及本公司收集哪些信息。此外，隐私政策如有更改，亦会发布在LINKTIVITY网站上，以向用户公开。',
          rule: []
        },
        {
          title: '11. 联系方式',
          subtitle:
            '如有关于本公司的隐私政策、个人信息保护措施、个人信息的收集和使用等方面的问题或要求公开等，请使用下面的信息联系，本公司的工作人员会在5个工作日内进行回复。\n\nリンクティビティ株式会社\n〒100-0011 東京都千代田区内幸町2-1-6 日比谷パークフロント 19F\n\n数据保护负责人的联系方式 dpo@linktivity.co.jp',
          rule: []
        },
        {
          title: '※此为翻译版本，实际以原文为准。',
          rule: []
        }
      ]
    },
    terms: {
      name: '使用条款',
      title: 'LINKTIVITY利用规约',
      lastUpdated: '最终更新日期 2020年05月01日',
      subtitle: `LINKTIVITY使用协议
LINKTIVITY株式会社（以下简称"本公司"）针对LINKTIVITY服务的使用，制定了以下LINKTIVITY使用协议（以下简称"本协议"）。

如果您使用了LINKTIVITY服务，则表明您已同意接受本协议的内容，请在使用LINKTIVITY服务时务必阅读本协议。此外，本协议可能会根据需要进行修改，请在使用LINKTIVITY服务时参考最新内容。

＊有关个人信息的处理，请阅读《个人信息保护方针》。`,
      content: [
        {
          title: '第一条 目的',
          content:
            '本协议适用于使用本公司运营的商品、服务等场地租赁（平台）销售网站"LINKTIVITY"服务的用户。使用本服务的用户应事先同意本协议，并在遵守本协议的基础上使用本服务。本协议也可能会在不事先通知的情况下进行修改。'
        },
        {
          title: '第二条 会员注册',
          content: `1."会员"指经本公司批准成为会员的个人。该个人在同意本协议的情况下，接受并完成本公司指定的会员注册手续后，根据本条款获得的本服务。但是，即使获得批准后，如果本公司认为该会员不适当，则可以撤销批准。
2.关于会员注册时所提供的信息，应真实、准确、有效。个人、注册信息（如姓名、电子邮件地址等）、密码应一一对应，同一人不得注册多个会员身份。
3.如果注册信息发生变更，会员必须立即进行规定的更改手续。`
        },
        {
          title: '第三条 商品供应商提供的信息',
          content:
            '本公司在LINKTIVITY上向会员提供商品供应商所提供的内容、费用、可购买日期、取消规定（取消政策）等购买所需信息（以下简称"购买相关信息"），以及商品供应商相关信息。购买相关信息由商品供应商负责提供，除非由于本公司故意或过失导致信息未能传递，否则本公司对购买相关信息的内容不承担任何责任。'
        },
        {
          title: '第四条 合同的成立',
          content:
            'LINKTIVITY平台上，会员所购买的商品、所提供的服务等相关合同，将由会员与商品供应商之间签订。在LINKTIVITY上发布商品、服务等内容仅是为了向商品供应商提出申请，当社有权代表商品供应商自由批准或拒绝该申请。本协议规定了会员使用LINKTIVITY服务的条件，包括使用LINKTIVITY向商品供应商提交购买申请的情况。但是，会员预订商品、提供服务等须遵循LINKTIVITY显示的合同条件、预订过程中提供的信息以及商品供应商规定的与商品、服务等相关的法律合同所规定的条件。'
        },
        {
          title: '第五条 费用支付',
          content: `LINKTIVITY作为商品供应商的代收款代理商，会获取会员的付款信息并处理付款。会员应在购买商品、服务等时，通过信用卡或本公司提供的支付方式向本公司支付费用。如果以外币表示，则本公司将按照确定的汇率，将信用卡支付金额或本公司提供的支付方式的结算金额换算为日元。

但是，部分付款应通过页面所指定的一种或多种方式支付。`
        },
        {
          title: '第六条 商品供应商所提供的商品、服务内容、质量',
          content:
            '本公司不对商品供应商所提供的商品、服务内容和质量负责，会员与商品供应商之间发生的任何问题、争议或投诉以及会员所遭受的任何损失，应与商品供应商协商解决，本公司对此不承担任何责任。'
        },
        {
          title: '第七条 使用环境',
          content: `1. 会员在使用LINKTIVITY时，应自行准备必要的通信设备、软件、通信手段等商品与服务，并自行负责与承担期间所产生的全部费用。
2. 会员在使用LINKTIVITY时，应自行准备必要的可以连接网络的智能手机、软件、通信手段等商品与服务，并自行负责与承担期间所产生的全部费用。`
        },
        {
          title: '第八条 会员因自身原因导致的取消订单与取消费用',
          content: `1. 会员因自身原因取消订单并产生的取消费用，将遵循商品供应商所规定的取消条款（取消政策）进行收取。
2. 本公司不对付款与退款时造成的外汇损益承担任何责任。
3. 原则上，会员需要登陆LINKTIVITY的"个人页面"并取消预订。但是，如果在使用日期前联系到商品供应商，并且商品供应商接受了取消订单，则稍后通过"个人页面"通知LINKTIVITY即可完成取消手续。`
        },
        {
          title: '第九条 商品供应商导致的取消订单与退款',
          content:
            '商品供应商对产品与服务等进行更改或取消时，应将由商品供应商直接通知会员，本公司对商品与服务等的更改或取消等不承担任何责任。但是，根据商品供应商的决定或要求，如果销售的商品或服务等内容发生更改或取消时，本公司可代为办理商品或服务等的退款业务。'
        },
        {
          title: '第十条 密码管理',
          content: `1.会员应对密码负责并加以管理。
2.会员不得将电子邮箱地址、密码提供给第三方使用，不得出借、转让、更名、买卖、抵押等。
3.因会员管理密码不当、使用失误、第三方使用等原因所引起的损害责任，由会员自行承担，本公司不承担任何责任。`
        },
        {
          title: '第十一条 会员注册信息的处理',
          content: `1. 在会员注册时，会员提供的个人信息（以下称为"注册信息"）将根据本公司的个人信息保护政策，由本公司进行管理和保管。
2. 本公司不会向第三方公开包含可识别个人身份的信息（以下称为"个人信息"）。但是，以下情况除外：

 i. 在获得客户同意的情况下公开信息时

 ii. 向已签订个人信息保护保密协议的业务外包商提供履行服务所需的个人信息时

 iii. 为了改善服务而进行个人信息的统计与分析，并在无法识别或无法确定个人身份的状态下公开或提供给第三方时

 iv. 根据法院发出的搜查令或经法院判断而要求公开信息时

此外，请阅读《个人信息保护政策》，以了解本公司获取的个人信息、使用目的和处理详情等内容。`
        },
        {
          title: '第十二条 会员的禁止事项',
          content: `会员在使用LINKTIVITY时，不得进行以下行为或可能导致以下行为的行为：

1.违反本协议的行为
2.违反公序良俗或法律法规的行为
3.侵犯本公司、其他会员或第三方的著作权、肖像权或其他知识产权的行为
4.诽谤或中伤其他会员或第三方的行为
5.给其他会员或第三方带来不利影响的行为
6.干扰本公司业务或妨碍本公司提供服务运营的行为
7.以营利为目的的行为
8.未经本公司事先同意，将做为会员所获得的权利转让或出借给第三方的行为
9.其他本公司认为不适当的行为`
        },
        {
          title: '第十三条 删除或修正会员发送的信息',
          content: `本公司可以在未经会员同意的情况下，删除会员发送的符合或可能属于以下任何一项的部分或全部信息，或进行本公司认为必要的任何修正：

1. 本公司认为符合本协议之"会员禁止事项"
2. 经本公司判断，所发送信息与事实不符
3. 本公司认为不适当的其他情况`
        },
        {
          title: '第十四条 取消会员资格',
          content: `如果会员属于以下任何一种情况时，本公司可以在未事先通知会员的情况下取消会员资格，且不对会员承担任何责任：

1. 违反本协议"会员禁止事项"的情况之一
2. 其他违反本协议的情况
3. 本公司认为该会员不符合会员资格的其他情况`
        },
        {
          title: '第十五条 服务的更改、暂停、终止',
          content: `1. 本公司可能在未事先通知会员的情况下，更改、暂停或终止服务内容。
2. 因本服务内容的更改、暂停或终止而造成会员的任何不利或损失时，本公司不承担任何责任。
3. 本公司可以提前一个月通知会员，并终止提供服务。`
        },
        {
          title: '第十六条 著作权及财产权',
          content:
            'LINKTIVITY上显示的所有内容的著作权及财产权，均属于本公司以及向本公司提供该内容的商品供应商、合作伙伴和广告商等个人或实体。除非获得本公司、商品供应商、合作伙伴和广告商的事先书面同意，否则使用者和会员同意不复制、公开、转让、出借、翻译、转载、传输、使用、再利用该等内容。此外，使用者和会员在进行上述行为期间所获得的利益相当的金额，本公司有权对使用者和会员进行赔偿。'
        },
        {
          title: '第十七条 免责及责任限制',
          content: `1.本公司与商品供应商之间发生的任何损害、会员因违反本协议所产生的任何损害、中商品或服务兑换过程中因非本公司原因造成的损害时，本公司不承担任何责任。
2.商品供应商是独立于本公司的合同主体，商品供应商的行为、过失、疏忽、代理行为、担保等，在会员参加商品活动或享受服务时，因受伤、死亡、财产损失、失窃或遭遇恐怖袭击等引起的任何损害或其他任何损害，本公司不承担任何责任。
3.对于超出本公司直接管理范围的商品或服务延迟、取消、重复购买、罢工等事件，本公司不承担任何负责。此外，由于政府机构、法院命令等原因而导致的内容更改、取消、延误、产生额外费用等时，本公司不承担任何回应义务。
4.当本公司提供本服务时，会员直接或间接地遭受了实际的、普通损失之外的损失时，即使本公司存在故意或过失行为，本公司不承担任何责任。`
        },
        {
          title: '第十八条 本协议的变更',
          content:
            '本公司保留在必要时更改本协议内容的权利。修改本协议时，只需在本页面上进行修改即可视为变更已完成，不会逐一通知会员。'
        },
        {
          title: '第十九条 管辖权',
          content:
            '关于本协议的任何争议，东京地方法院将作为第一审的专属管辖法院。'
        },
        {
          title: '第二十条 协商',
          content:
            '如对本协议未规定事项或对本协议有任何疑问，双方应本着诚信协商，友好地努力共寻解决之道。'
        },
        {
          title: '※此为翻译版本，实际以原文为准。',
          content: ''
        }
      ]
    }
  },
  cancelTerms: {
    title: '取消规则',
    textTitle: 'GOx旅日打车取消规则',
    content: [
      {
        title: '取消费说明',
        content: [
          '当司机接单超过3分钟或已到达上车点时，若您取消订单，供应商可能会收取取消费。',
          '由于不同供应商的取消费规则可能存在差异，具体费用标准请以供应商提供的信息为准。'
        ]
      },
      {
        title: '取消费用用途',
        content: [
          '平台收取的取消费将用于补偿司机因行程取消所产生的空驶成本，以保障司机权益。'
        ]
      },
      {
        title: '您需支付取消费的情况',
        content: [
          '若您在超过规定时间后取消订单，导致司机产生空驶成本，您需要支付取消费作为补偿。',
          '具体取消费用标准将依据供应商的规则计算，系统将在取消时向您展示相应的费用。'
        ]
      },
      {
        title: '您无需支付取消费的情况',
        content: [
          '在规定时间内取消订单，您无需支付取消费。',
          {
            title: '若因以下原因取消订单，取消费可予以免除：',
            content: [
              '司机主动取消订单',
              '司机未按预定时间到达上车点',
              '司机拒载或无故不来接乘客',
              '其他因司机原因导致的订单无法正常进行'
            ]
          },
          '若因上述情况产生取消费，您可联系客服申诉，平台将在核实后进行取消费豁免处理。'
        ]
      },
      {
        title: '争议处理',
        content: [
          '若您对取消费用有异议，可在订单取消后24小时内联系客服进行申诉。',
          '平台将依据订单记录、司机反馈及相关证据进行核实，并在核实完成后做出最终处理决定。'
        ]
      }
    ],
    bottomDesc: '感谢您选择GOx旅日打车平台，祝您出行愉快！'
  },
  components: {
    confirm: {
      confirm: '确定',
      cancel: '取消'
    },
    map: {
      locationPermission: {
        harmony:
          '无法获取您的位置。请前往手机「设置 > 应用和元服务 > 位置」开启位置服务，并允许本服务使用位置信息。',
        wechat:
          '无法获取您的位置。请前往手机「设置」开启定位服务，并允许微信使用位置信息。',
        ios: '无法获取您的位置。请前往「设置 > 隐私与安全性 > 定位服务」开启定位服务，并允许当前浏览器使用位置信息。',
        android:
          '无法获取您的位置。请前往手机「设置 > 位置信息」开启位置服务，并在浏览器的网站设置中允许本网站使用位置信息。',
        default: '无法获取您的位置。请在浏览器设置中允许本网站使用位置信息。'
      },
      locationPermissionConfirm: '我知道了'
    },
    hotel: {
      back: '返回',
      multiLanguage: 'EN/中/日/한'
    }
  },
  common: {
    noData: '暂无数据',
    copyright: '© LINKTIVITY Inc. All Rights Reserved.'
  },
  errorCode: {
    [ErrorCode.Internal]: '系统繁忙，请稍后再试',
    [ErrorCode.Unauthorized]: '登录已过期，请重新登录',
    [ErrorCode.InvalidArgument]: '输入信息有误，请重新输入',
    [ErrorCode.PaymentFailed]: '支付失败，请重新尝试',
    [ErrorCode.PendingPaymentExist]: '您有未完成的支付订单，请先处理',
    [ErrorCode.PaymentNotCompleted]: '支付尚未完成，请继续支付',
    [ErrorCode.LoginFailed]: '登录失败，请重新尝试',
    [ErrorCode.RefundFailed]: '退款失败，请联系客服处理',
    [ErrorCode.AccessTokenExpired]: '登录已过期，请重新登录',
    [ErrorCode.TaxiNotFound]: '暂无可用车辆，请稍后再试',
    [ErrorCode.InvalidLocation]: '位置信息无效，请重新选择',
    [ErrorCode.NotCancellable]: '当前订单状态不可取消',
    [ErrorCode.DeadlineExceeded]: '系统繁忙，请稍后再试',
    [ErrorCode.CouponNotFound]: '优惠券不存在',
    [ErrorCode.CouponExpired]: '优惠券已过期',
    [ErrorCode.CouponAlreadyUsed]: '优惠券已使用',
    [ErrorCode.CouponNotApplicable]: '优惠券不适用',
    [ErrorCode.CouponAlreadyRedeemed]: '您已兑换过此类优惠券',
    [ErrorCode.CouponOutOfAllotment]: '优惠券已发放完',
    [ErrorCode.CouponEventEnded]: '优惠券活动已结束',
    [ErrorCode.CouponEventNotStarted]: '优惠券活动未开始'
  },
  firebase: {
    'auth/wrong-password': '登录名或密码错误',
    'auth/user-not-found': '登录名或密码错误',
    'auth/email-already-in-use': '邮箱已存在',
    'auth/too-many-requests': '登录尝试次数超过上限。请稍后再试，或重置密码。'
  }
};
